import BarcodeScanner from './barcodeScanner';

export default BarcodeScanner;
